// import external dependencies

import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateElenco from './routes/template-elenco';
import templatePrograma from './routes/template-programa';
import templateElencoslide from './routes/template-elencoslide';
import templateOpiniones from './routes/template-opiniones';
import templateEntradas from './routes/template-entradas';
import templateEntradasBarcelona from './routes/template-entradasBarcelona';
import templateEntradaslanding from './routes/template-entradaslanding';
import templateEquipocreativo from './routes/template-equipocreativo';
import templateGrupos from './routes/template-grupos';
import templateTeatro from './routes/template-teatro';
import landingSorteo from './routes/landing-sorteo';
import singleCiudad from './routes/single-ciudad';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  templateElenco,

  templateElencoslide,

  templatePrograma,

  templateOpiniones,

  templateEntradas,

  templateEntradaslanding,

  templateEquipocreativo,

  templateGrupos,

  templateTeatro,

  landingSorteo,

  singleCiudad,

  templateEntradasBarcelona,
  pageTemplateTemplateEntradasbarcelona: templateEntradasBarcelona,

});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js